module.exports = __webpack_public_path__ + "aa9b3345ab947fb2b8e4bec0a6455715.svg";